export default {
  'Start at': '음악이 xx 시 시작됩니다.',
  'Set to current time': '현재 시간으로 설정합니다',
  'Audio volume': '오디오 볼륨',
  'Video volume': '비디오 볼륨',
  'Trim audio': '오디오 편집',
  'Audio will end with the video': '음성은 영상이 끝나면서 끝이 납니다.',
  'Trim': '절취',
}